import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import colors from 'components/utils/colors'
import PropTypes from 'prop-types'

const InfoLine = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  height: 32px;
  color: ${colors.contentSecondaryActive};
  padding: 0 12px 4px 12px;
`

const ConfirmDialogBody = ({ additionalProps }) => {
  const { t } = useTranslation()
  const message = additionalProps.message || t('common.justificationInfoLineShort')

  return (
    <InfoLine data-test='confirm-info-line'>{message}</InfoLine>
  )
}

ConfirmDialogBody.propTypes = {
  additionalProps: PropTypes.object,
}

export default ConfirmDialogBody
